// Bridge network configuration
export interface BridgeToken {
  address: string;
  name: string;
  symbol: string;
  decimals: number;
  logoURI: string;
  checkLock: boolean;
  resourceId: string;
}

export interface BridgeNetwork {
  id: number;
  networkId: number;
  name: string;
  type: string;
  decimals: number;
  iconURI: string;
  relay: string;
  bridge: string;
  erc20Handler: string;
  endpoint: string;
  scanURL: string;
  nativeTokenSymbol: string;
  blockConfirmations: number;
  startBlock: number;
  gasNeed: string;
  tokens: BridgeToken[];
}

export const BRIDGE_NETWORKS: BridgeNetwork[] = [
  {
    "id": 1,
    "networkId": 9898,
    "name": "Larissa",
    "type": "evm",
    "decimals": 18,
    "iconURI": "https://tokens.larissa.network/logo.png",
    "relay": "0x6A0694e7a996610B0eB581ceD32B43691cE9D5e6",
    "bridge": "0x9350795c2A6E2ec7a28E442248D9332EfBd79231",
    "erc20Handler": "0x0f4330CcA3a44BF7545ca0a2a071DEcd821b6643",
    "endpoint": "https://rpc.larissa.network",
    "scanURL": "https://scan.larissa.network",
    "nativeTokenSymbol": "LRS",
    "blockConfirmations": 5,
    "startBlock": 323180,
    "gasNeed": "145524",
    "tokens": [
      {
        "address": "0x2347302968D7D7CD25aa82Ff8BE78850AD8119F7",
        "name": "Wrapped LRS",
        "symbol": "WLRS",
        "decimals": 18,
        "logoURI": "https://tokens.larissa.network/images/0x2347302968D7D7CD25aa82Ff8BE78850AD8119F7.png",
        "checkLock": true,
        "resourceId": "0x2347302968d7d7cd25aa82ff8be78850ad8119f7574c52532d4c525300000000"
      },
      {
        "address": "0x13c378660cddA2AfccEa093f5e0743D5Ec37a822",
        "name": "Tether USD",
        "symbol": "USDT",
        "decimals": 6,
        "logoURI": "https://tokens.larissa.network/images/tether-usdt-logo.png",
        "checkLock": false,
        "resourceId": "0x2347302968d7d7cd25aa82ff8be78850ad8119f7555344542d55534454000000"
      },
      {
        "address": "0x5B5E3Aa46Cf811eB545617dCc25856e06D07D7ad",
        "name": "USD Coin",
        "symbol": "USDC",
        "decimals": 6,
        "logoURI": "https://tokens.larissa.network/images/usd-coin-usdc-logo.svg",
        "checkLock": false,
        "resourceId": "0x2347302968d7d7cd25aa82ff8be78850ad8119f7555344432d55534443000000"
      }
    ]
  },
  {
    "id": 2,
    "networkId": 1,
    "name": "Ethereum",
    "type": "evm",
    "decimals": 18,
    "iconURI": "https://tokens.larissa.network/chains/eth-logo.png",
    "relay": "0x6A0694e7a996610B0eB581ceD32B43691cE9D5e6",
    "bridge": "0x2347302968D7D7CD25aa82Ff8BE78850AD8119F7",
    "erc20Handler": "0x9Ca746d4648978A9418F4730394C8A3d58f17eDD",
    "endpoint": "https://eth.llamarpc.com",
    "scanURL": "https://etherscan.io",
    "nativeTokenSymbol": "ETH",
    "blockConfirmations": 5,
    "startBlock": 19324023,
    "gasNeed": "145524",
    "tokens": [
      {
        "address": "0x6483DE4a2C76A38f288C4922fE2F507B2322eF80",
        "name": "Larissa",
        "symbol": "LRS",
        "decimals": 18,
        "logoURI": "https://tokens.larissa.network/logo.png",
        "checkLock": false,
        "resourceId": "0x2347302968d7d7cd25aa82ff8be78850ad8119f7574c52532d4c525300000000"
      },
      {
        "address": "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        "name": "Tether USD",
        "symbol": "USDT",
        "decimals": 6,
        "logoURI": "https://tokens.larissa.network/images/tether-usdt-logo.png",
        "checkLock": true,
        "resourceId": "0x2347302968d7d7cd25aa82ff8be78850ad8119f7555344542d55534454000000"
      },
      {
        "address": "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        "name": "USD Coin",
        "symbol": "USDC",
        "decimals": 6,
        "logoURI": "https://tokens.larissa.network/images/usd-coin-usdc-logo.svg",
        "checkLock": true,
        "resourceId": "0x2347302968d7d7cd25aa82ff8be78850ad8119f7555344432d55534443000000"
      }
    ]
  },
  {
    "id": 3,
    "networkId": 137,
    "name": "Polygon",
    "type": "evm",
    "decimals": 18,
    "iconURI": "https://tokens.larissa.network/chains/matic-logo.png",
    "relay": "0x6A0694e7a996610B0eB581ceD32B43691cE9D5e6",
    "bridge": "0x2347302968D7D7CD25aa82Ff8BE78850AD8119F7",
    "erc20Handler": "0xebf9F715BAEecb0dA265A933BF5d369BdDc9030A",
    "endpoint": "https://1rpc.io/matic",
    "scanURL": "https://polygonscan.com",
    "nativeTokenSymbol": "MATIC",
    "blockConfirmations": 5,
    "startBlock": 54097558,
    "gasNeed": "140376",
    "tokens": [
      {
        "address": "0x6483DE4a2C76A38f288C4922fE2F507B2322eF80",
        "name": "Larissa",
        "symbol": "LRS",
        "decimals": 18,
        "logoURI": "https://tokens.larissa.network/logo.png",
        "checkLock": false,
        "resourceId": "0x2347302968d7d7cd25aa82ff8be78850ad8119f7574c52532d4c525300000000"
      },
      {
        "address": "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
        "name": "Tether USD",
        "symbol": "USDT",
        "decimals": 6,
        "logoURI": "https://tokens.larissa.network/images/tether-usdt-logo.png",
        "checkLock": true,
        "resourceId": "0x2347302968d7d7cd25aa82ff8be78850ad8119f7555344542d55534454000000"
      },
      {
        "address": "0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359",
        "name": "USD Coin",
        "symbol": "USDC",
        "decimals": 6,
        "logoURI": "https://tokens.larissa.network/images/usd-coin-usdc-logo.svg",
        "checkLock": true,
        "resourceId": "0x2347302968d7d7cd25aa82ff8be78850ad8119f7555344432d55534443000000"
      }
    ]
  },
  {
    "id": 4,
    "networkId": 56,
    "name": "Binance",
    "type": "evm",
    "decimals": 18,
    "iconURI": "https://tokens.larissa.network/chains/bnb-bnb-logo.svg",
    "relay": "0x6A0694e7a996610B0eB581ceD32B43691cE9D5e6",
    "bridge": "0xebf9F715BAEecb0dA265A933BF5d369BdDc9030A",
    "erc20Handler": "0xAEc7F537916D954b30032A5221E65CDf4CDC3560",
    "endpoint": "https://bsc-dataseed.bnbchain.org",
    "scanURL": "https://bscscan.com",
    "nativeTokenSymbol": "BNB",
    "blockConfirmations": 5,
    "startBlock": 46615953,
    "gasNeed": "140376",
    "tokens": [
      {
        "address": "0x6483DE4a2C76A38f288C4922fE2F507B2322eF80",
        "name": "Larissa",
        "symbol": "LRS",
        "decimals": 18,
        "logoURI": "https://tokens.larissa.network/logo.png",
        "checkLock": false,
        "resourceId": "0x2347302968d7d7cd25aa82ff8be78850ad8119f7574c52532d4c525300000000"
      },
      {
        "address": "0x55d398326f99059fF775485246999027B3197955",
        "name": "Tether USD",
        "symbol": "USDT",
        "decimals": 18,
        "logoURI": "https://tokens.larissa.network/images/tether-usdt-logo.png",
        "checkLock": true,
        "resourceId": "0x2347302968d7d7cd25aa82ff8be78850ad8119f7555344542d55534454000000"
      },
      {
        "address": "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
        "name": "USD Coin",
        "symbol": "USDC",
        "decimals": 18,
        "logoURI": "https://tokens.larissa.network/images/usd-coin-usdc-logo.svg",
        "checkLock": false,
        "resourceId": "0x2347302968d7d7cd25aa82ff8be78850ad8119f7555344432d55534443000000"
      }
    ]
  }
];

// Helper function to get network by ID
export function getNetworkById(networkId: number): BridgeNetwork | undefined {
  return BRIDGE_NETWORKS.find(network => network.networkId === networkId);
}

// Helper function to get common tokens between two networks
export function getCommonTokens(fromNetworkId: number, toNetworkId: number): BridgeToken[] {
  const fromNetwork = getNetworkById(fromNetworkId);
  const toNetwork = getNetworkById(toNetworkId);
  
  if (!fromNetwork || !toNetwork) return [];
  
  // Find tokens with matching resourceIds
  const commonTokens: BridgeToken[] = [];
  fromNetwork.tokens.forEach(fromToken => {
    const matchingToken = toNetwork.tokens.find(
      toToken => toToken.resourceId === fromToken.resourceId
    );
    if (matchingToken) {
      commonTokens.push(fromToken);
    }
  });
  
  return commonTokens;
}

